module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/pre-loaders/custom-loader-1/custom-loader-1.component.scss
// module id = ./src/app/features/pre-loaders/custom-loader-1/custom-loader-1.component.scss
// module chunks = main